// Socket helper functions
// Note: Actual socket instance is managed in SocketContext
import type { Socket } from 'socket.io-client';

export function getSocket(): Socket | null {
  // Return null or socket instance from context
  return null;
}

export function setSocketAuthToken(_token: string): void {
  // Stub for now
}

export function trackRoom(_roomId: string): void {
  // Stub for now
}

export function untrackRoom(_roomId: string): void {
  // Stub for now
}

export function joinRoom(_roomId: string): void {
  // Stub for now
}

export function leaveRoom(_roomId: string): void {
  // Stub for now
}
